import React, { useMemo, useState } from 'react';
import { FileText } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { bookingApi } from '../api/bookingApi';
import { openInvoicePrint } from '../utils/invoicePrint';

const TrackInvoiceAccess = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const trackingId = useMemo(() => {
    const match = location.pathname.match(/^\/track\/([^/]+)\/?$/i);
    return match?.[1] ? decodeURIComponent(match[1]) : '';
  }, [location.pathname]);

  if (!trackingId) return null;

  const viewInvoice = async () => {
    setLoading(true);
    setMessage('');
    try {
      const [invoiceResponse, bookingResponse] = await Promise.all([
        bookingApi.trackInvoice(trackingId),
        bookingApi.track(trackingId),
      ]);
      openInvoicePrint({
        invoice: invoiceResponse.data,
        kind: 'client',
        booking: bookingResponse.data || { trackingId },
      });
    } catch (err) {
      if (err.response?.status === 404) {
        setMessage('Your invoice will be available here after the deposit is paid.');
      } else {
        setMessage(err.response?.data?.message || "Couldn't load your invoice.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="border-b border-green-100 bg-green-50/95">
      <div className="mx-auto flex min-h-12 w-full items-center justify-between gap-3 px-4 py-2 sm:px-6 lg:px-8 2xl:px-10">
        <div className="min-w-0">
          <div className="flex items-center gap-2 text-xs font-bold text-green-900 sm:text-sm">
            <FileText size={16} className="shrink-0 text-green-700" />
            <span>Client invoice / receipt</span>
          </div>
          {message && <div className="mt-0.5 break-words text-[11px] text-green-800 sm:text-xs">{message}</div>}
        </div>
        <button
          type="button"
          onClick={viewInvoice}
          disabled={loading}
          className="shrink-0 cursor-pointer rounded-lg border border-green-200 bg-white px-3 py-2 text-xs font-bold text-green-800 transition hover:border-green-400 hover:bg-green-50 disabled:cursor-not-allowed disabled:opacity-60 sm:px-4"
        >
          {loading ? 'Loading…' : 'View invoice'}
        </button>
      </div>
    </div>
  );
};

export default TrackInvoiceAccess;
